import React from "react";
import { FaBars, FaSignOutAlt, FaUserCircle } from "react-icons/fa";
import { useAuth } from "../../contexts/AuthContext";

function AdminTopbar({ onToggleSidebar }) {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <header className="admin-topbar">
      <button
        type="button"
        className="admin-topbar__hamburger"
        onClick={onToggleSidebar}
        aria-label="Toggle navigation menu"
      >
        <FaBars />
      </button>

      <div className="admin-topbar__spacer" />

      <div className="admin-topbar__user">
        <FaUserCircle className="admin-topbar__user-icon" />
        <span className="admin-topbar__username">
          {user?.name || "Admin"}
        </span>
        <button
          type="button"
          className="admin-topbar__logout"
          onClick={handleLogout}
        >
          <FaSignOutAlt className="admin-topbar__logout-icon" />
          <span>Logout</span>
        </button>
      </div>
    </header>
  );
}

export default AdminTopbar;
